<template>
  <ODialog ref="dialog" hideWhenLoading :maxWidth="450">
    <v-card v-if="row != null">
      <ODialogBar title="Referência de Valores" @close="dismiss" />
      <v-card-text class="pa-3 maxh-4">
        <label class="light-caption">Valores base</label>
        <ValuesTable :values="baseValues" @itemClicked="apply" />

        <label class="light-caption mt-6">Adicionais</label>
        <ValuesTable :values="extraValues" @itemClicked="apply" />
      </v-card-text>
    </v-card>
  </ODialog>
</template>

<script>
import { Technician } from '@/models'
import ValuesTable from './ValuesTable.vue'

export default {
  components: { ValuesTable },
  data() {
    return { row: null }
  },
  computed: {
    baseValues() {
      if (this.row == null) return null
      return [
        { name: 'Instalação Oderon Fox', value: this.row.installValue },
        { name: 'Retirada Oderon Fox', value: this.row.removeValue }
      ]
    },

    extraValues() {
      if (this.row == null) return null
      return this.row.values
    }
  },
  methods: {
    async open(technicianId) {
      if (technicianId == null) {
        this.$info({
          message: 'Selecione um técnico para ver a sua referência de valores.'
        })
      } else {
        this.row = null
        this.$refs.dialog.$loading(async () => {
          this.row = await Technician.findById(technicianId)
        })
        return this.$refs.dialog.$open()
      }
    },

    apply(x) {
      this.$refs.dialog.$apply(x.value)
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    }
  }
}
</script>

<style></style>
